import { render } from "./game-play-msg-box.vue?vue&type=template&id=6141e82d&scoped=true&ts=true"
import script from "./game-play-msg-box.vue?vue&type=script&lang=ts"
export * from "./game-play-msg-box.vue?vue&type=script&lang=ts"

import "./game-play-msg-box.vue?vue&type=style&index=0&id=6141e82d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6141e82d"]])

export default __exports__